/*
 * Action Types
 */
export enum LotsTypes {
  LIST_LOTS_REQUEST = '@lots/LIST_LOTS_REQUEST',
  LIST_LOTS_SUCCESS = '@lots/LIST_LOTS_SUCCESS',
  LIST_LOTS_FAILURE = '@lots/LIST_LOTS_FAILURE',

  GET_LOT_REQUEST = '@lots/GET_LOT_REQUEST',
  GET_LOT_SUCCESS = '@lots/GET_LOT_SUCCESS',
  GET_LOT_FAILURE = '@lots/GET_LOT_FAILURE',

  FILTER_LOTS_REQUEST = '@lots/FILTER_LOTS_REQUEST',
  FILTER_LOTS_SUCCESS = '@lots/FILTER_LOTS_SUCCESS',
  FILTER_LOTS_FAILURE = '@lots/FILTER_LOTS_FAILURE',

  CREATE_LOT_REQUEST = '@lots/CREATE_LOT_REQUEST',
  CREATE_LOT_SUCCESS = '@lots/CREATE_LOT_SUCCESS',
  CREATE_LOT_FAILURE = '@lots/CREATE_LOT_FAILURE',

  UPDATE_LOT_REQUEST = '@lots/UPDATE_LOT_REQUEST',
  UPDATE_LOT_SUCCESS = '@lots/UPDATE_LOT_SUCCESS',
  UPDATE_LOT_FAILURE = '@lots/UPDATE_LOT_FAILURE',

  DELETE_LOT_REQUEST = '@lots/DELETE_LOT_REQUEST',
  DELETE_LOT_SUCCESS = '@lots/DELETE_LOT_SUCCESS',
  DELETE_LOT_FAILURE = '@lots/DELETE_LOT_FAILURE',
}

/*
 * Data types
 */
export interface LotInterface {
  id: string;
  value: number;
  startDate: string;
  endDate: string;
  transportOperatorId: string;
  name: string;

  creationDate?: string;
  initialValue?: number;
  remainingValue?: number;
  authorizedBy?: string;
}

/*
 * State type
 */
export interface LotsState {
  readonly lotsList: LotInterface[];
  readonly lotData: LotInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
